import classNames from 'classnames'
import { DateTime } from 'luxon'

import { renderAmount } from '~/lib/helpers'

import styles from './LockInfo.pcss'
import { patchExpiresDate } from '~/lib/patchExpiresDate'
import { useVESISParams } from '~/hooks/useVESISParams'

interface Props {
	amount: string
	expiresDate: DateTime
	isUnlock: boolean
	rewards: string
}

export function LockInfo({ amount, expiresDate, isUnlock, rewards }: Props) {
	const { config } = useVESISParams()

	return (
		<div className={styles.container}>
			<div className={styles.row}>
				<div
					className={classNames(
						styles.column,
						styles.title,
						styles.value
					)}
				>
					Amount
				</div>
				<div
					className={classNames(
						styles.column,
						styles.title,
						styles.value
					)}
				>
					Claimed rewards
				</div>
				<div
					className={classNames(
						styles.column,
						styles.title,
						styles.expires
					)}
				>
					Expires
				</div>
			</div>
			<div className={styles.row}>
				<div className={classNames(styles.column, styles.value)}>
					{renderAmount(amount, 6)} SIS
				</div>
				<div className={classNames(styles.column, styles.value)}>
					{renderAmount(rewards, 6)} SIS
				</div>
				<div
					className={classNames(
						styles.column,
						styles.expires,
						isUnlock && styles.unlock
					)}
				>
					{isUnlock
						? 'Unlock'
						: patchExpiresDate(
								config,
								expiresDate
						  ).toLocaleString()}
				</div>
			</div>
		</div>
	)
}
